exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-navbar {\n  height: 100px; }\n  .help-navbar .navbar-brand {\n    font-size: 2rem;\n    font-weight: 700;\n    color: white !important; }\n    .help-navbar .navbar-brand:hover {\n      cursor: pointer; }\n  .help-navbar .navbar-nav .btn {\n    border-radius: 20px;\n    text-transform: uppercase; }\n", ""]);

// exports
